import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';

interface HeadPhoneCloseModalProps {
    isOpen: boolean;
    onClose: () => void;
    language?: {
        isEnglish: boolean;
        isKorean: boolean;
    };
}

export function HeadPhoneGuideModal({ isOpen, onClose, language }: HeadPhoneCloseModalProps) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))] tts-modal">
            <div className="flex h-full flex-col">
                <header className="text-[var(--text-black-01)] px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(30*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={0} data-interactive aria-label={t('headPhoneGuide.title')} className="text-center font-bold focus-border ">
                        {t('headPhoneGuide.title')}
                    </h1>
                </header>
                <main className={`${language?.isEnglish || language?.isKorean ? 'px-[calc(90*var(--vw-unit))]' : 'px-[calc(56*var(--vw-unit))]'}`}>
                    <div className="mt-[calc(24*var(--vh-unit))] mb-[calc(40*var(--vh-unit))]">
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={t('headPhoneGuide.ariaDescription1')}
                            className={`text-[var(--text-black-02)] focus-border  text-center text-[calc(22*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))] ${language?.isEnglish || language?.isKorean ? '' : 'whitespace-nowrap'
                                }`}
                            dangerouslySetInnerHTML={{ __html: t('headPhoneGuide.description1') }}
                        ></p>
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={t('headPhoneGuide.description2')}
                            className={`text-[var(--text-black-02)] focus-border  ${language?.isEnglish || language?.isKorean ? 'mt-[calc(30*var(--vh-unit))]' : ''
                                }  text-center text-[calc(22*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))]`}
                            dangerouslySetInnerHTML={{ __html: t('headPhoneGuide.description2') }}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center gap-[calc(23*var(--vw-unit))] px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton role="button" variant="primary" aria-label={t('headPhoneGuide.buttons.confirm')} onClick={onClose} data-interactive type="button">
                        {t('headPhoneGuide.buttons.confirm')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
